import React from 'react';
import { Typography } from '@parkschannel/ui';
import classNames from 'classnames';

export interface LoadingProps {
  className?: string;
  children?: React.ReactNode;
}

export const Loading: React.FC<LoadingProps> = ({ className, children }) => {
  return (
    <div
      className={classNames(
        'w-full text-center my-5 flex justify-center items-center',
        className
      )}
    >
      <Typography
        component="span"
        variant="bodyLarge"
        className="text-neutral-800 "
      >
        {children || 'Loading...'}
      </Typography>
    </div>
  );
};
